import { ReactElement } from 'react';
import { Link } from 'react-router-dom';
import classnames from 'classnames';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import IconButton from '@material-ui/core/IconButton';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

import { IHospitalEventList } from '~/services/api/hospital/types';
import { PATIENT_DASHBOARD } from '~/ui/constants/paths';
import { isoToFormat } from '~/utils/date';
import styles from './Item.module.scss';
import { DATE_TIME_FORMAT } from '../../DetailsModal/constants';

interface IProps {
  event: IHospitalEventList;
  onOpenDetails: (event: IHospitalEventList) => void;
}

const Item = ({ event, onOpenDetails }: IProps): ReactElement => {
  const receivedBySystem = `Received by system: ${isoToFormat(
    event.processedAt,
    DATE_TIME_FORMAT,
    event.patientTimezone,
  )}`;

  return (
    <TableRow>
      <TableCell>
        <IconButton
          className={classnames(styles.icon, styles.infoIcon)}
          title="Details"
          onClick={() => onOpenDetails(event)}
        >
          <InfoOutlinedIcon />
        </IconButton>
      </TableCell>
      <TableCell>{event.eventName || event.eventId}</TableCell>
      <TableCell className={styles.cell}>
        <Link
          to={PATIENT_DASHBOARD.replace(':id', String(event.patientId))}
          className={styles.link}
        >
          {event.patientFullName}
        </Link>
      </TableCell>
      <TableCell title={receivedBySystem}>
        {isoToFormat(event.messageTimestamp, DATE_TIME_FORMAT, event.patientTimezone)}
      </TableCell>
      <TableCell className={styles.cell}>{event.programName}</TableCell>
      <TableCell className={styles.cell}>{event.facility || '-'}</TableCell>
      <TableCell className={styles.cell}>{event.reason || '-'}</TableCell>
    </TableRow>
  );
};

export default Item;
